import React, { useState, useRef, useEffect } from 'react'
import {
  Button, Grid, Typography, Modal, Fade, Box, Icon, Tabs, Tab, RadioGroup, IconButton, Popper, Radio, FormControlLabel, Checkbox, TextField, InputAdornment,
  List, ListItem, ListItemAvatar, Avatar, ListItemText, ListItemSecondaryAction, LinearProgress, ClickAwayListener
} from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import toast from 'react-hot-toast';
import { makeStyles, withStyles } from '@mui/styles';
import { getDashboarDetails } from '../../config/services/dashboards';
import DashboardChartLayoutV2 from '../../components/_report/dashboard/DashboardChartLayoutV2';
import { styled } from '@mui/material/styles';
import { Outlet } from 'react-router-dom';
import { ReactComponent as ProfileIcon } from "../../assets/icons/profile-icon-1.svg";
import { ReactComponent as DropDownIcon } from "../../assets/icons/icon-angle-down.svg";
import { ReactComponent as CalendarIcon } from "../../assets/icons/icon_calender.svg";
import { ReactComponent as SyllabusIcon } from "../../assets/icons/icon-syllabus.svg";
import GenericIcon from '../../assets/icons/Generic_Icon.svg'
import { ReactComponent as TimerIcon } from "../../assets/icons/icon-timer.svg";
import CancelButton from "../../assets/icons/icon-cancel.svg";
import ReactEcharts from "echarts-for-react";
import DatePicker from "react-datepicker";
import { DecryptData } from '../../utils/encryptDecrypt'
import UAParser from "ua-parser-js";
import getDataFromCube from '../../utils/getCubeData';
import { getMeasuresList, findMeasureByNameAndDataSetId } from '../../config/services/measures';
import _ from 'lodash';
import { getDataSetDetails } from '../../config/services/datasets';
import Loader from '../Loader';
import { FixedSizeList } from "react-window";
import AutoSizer from "react-virtualized-auto-sizer";
import iconsData from '../../utils/subjectsIconsData'
import { ReactComponent as ReportChart } from "../../assets/icons/icon-report-data.svg"
import { multiLangData, handleLanguageChange, lang, setLanguage, updateLanguage } from '../../utils/multiLangDashboardV2Data';
import settings from "../../config/settings";
import moment from 'moment'
import { useLocation } from 'react-router-dom'
import { setHours, setMinutes } from 'date-fns'
import { isArrayEqual } from '../../utils/Reusables';
import { PORFILE_AVATAR, SUBJECT_ICON } from '../../constants/externalUrls'
import PerformanceCards from './PerformanceCards'
import KeyTimePerformance from './KeyTimePerformance'
import KeyMarksPerformance from './KeyMarksPerformance'
import { generateCustomDateRange } from '../../utils/Reusables'

import { CarouselPrevArrow, CarouselNextArrow, isMobileView } from "./../../utils/Reusables";
// import Slider from "react-slick";
import { ReactComponent as CheckBoxIcon } from '../../assets/icons/icon-checkbox-unchecked.svg';
import { ReactComponent as CheckBoxCheckedIcon } from '../../assets/icons/icon-checkbox-checked.svg';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';
import 'swiper/swiper.min.css'
import 'swiper/modules/navigation/navigation.min.css';
import { ReactComponent as RightNavIcon } from "../../assets/icons/icon-angle-right-main.svg";
import { ReactComponent as LeftNavIcon } from "../../assets/icons/icon-angle-left-main.svg";

// ----------------------------------------------------------------------
let dataSetMeasureList = {}
const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 92;

const RootStyle = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden'
});

const MainStyle = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
}));


export default function ChartDashboardV2({ studentId }) {


  const { env, STUDENT_DASHBOARD_QUERY, STUDENT_DASHBOARD_ID, STUDENT_DASHBOARD_CALCULATED_FIELDS, STUDENT_PROFILE_DATASET } = settings

  const [layout, setLayout] = useState([[]]);
  const bodyRef = React.createRef();
  const [sheetsAvailable, setSheetsAvailable] = useState([]);
  const [selectedSheetIndex, setSelectedSheetIndex] = useState(0);
  const [dashBoardDetails, setDashBoardDetails] = useState([])
  const [filterOptions, setFilterOptions] = useState([]);
  const [valueList, setValueList] = useState([]);

  const [profiles, setProfiles] = useState([]);
  const [currentProfile, setCurrentProfile] = React.useState("all");
  const [activeItemIndex, setActiveItemIndex] = useState(0);
  const chevronWidth = 0;
  const [statistics, setStatstics] = useState([]);
  const [statsCardClasses, setStatsCardClasses] = useState(["first", "second", "third", "fourth"]);
  const [keyAreas1, setKeyAreas1] = useState([]);
  const [keyAreas2, setKeyAreas2] = useState([]);
  const [deviceType, setDeviceType] = useState('desktop');
  const [carousalCards, setCarousalCards] = useState(4);
  const [carousalWidth, setCarousalWidth] = useState('100%');
  const [currentUser, setCurrentUser] = useState(DecryptData(localStorage.getItem('s_uuid')) || '')
  const [selectedSubjects, setSelectedSubjects] = useState([])
  const [loading, setLoading] = useState(false)
  const [noDataKeyArea2, setNoDataKeyArea2] = useState(false)
  const [noDataKeyArea1, setNoDataKeyArea1] = useState(false)
  const [selectedProfile, setSelectedProfile] = useState([])
  const [profileReportIds, setProfileReportIds] = useState([])
  const [selectedTab, setSelectedTab] = useState('all.0')
  const [learningProfileMapping, setLearningProfileMapping] = useState([])
  const [showKeyMarksPerformance, setshowKeyMarksPerformance] = useState(true)
  const [showKeyTimePerformance, setshowKeyTimePerformance] = useState(true)
  const [maxStartDate, setMaxStartDate] = useState(Date.now())
  const [chevronVisibility, setChevronVisibility] = useState(true)
  const [minEndDate, setMinEndDate] = useState(new Date("01/01/2021"))
  const [isSameDayStartTime, setIsSameDayStartTime] = useState(false)
  const [disabledProp, setDisabledProp] = useState(false)
  const [isSameDayEndTime, setIsSameDayEndTime] = useState(false)
  const search = useLocation().search;
  const language = new URLSearchParams(search).get('lang');
  const [tempFilterState, setTempFilterState] = useState([])
  const [subjectIconData, setSubjectIconData] = useState([])

  const [subjectFilterData, setSubjectFilterData] = useState([]);
  const [filterInputEl, setFilterInputEl] = React.useState(null);
  const [filterInputEl1, setFilterInputEl1] = React.useState(null);
  const [filterInputOpen, setFilterInputOpen] = React.useState(false);
  const [filterInputOpen1, setFilterInputOpen1] = React.useState(false);

  const [selectFilterWidth, setSelectFilterWidth] = useState('200px');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [subjectsLoader, setSubjectsLoader] = useState(false);
  const [selectedPeriod, setSelectedPeriod] = useState("")
  let [keyTimeMetricsQuery, setKeyTimeMetricsQuery] = useState(null)
  let [keyMarksMetricsQuery, setKeyMarksMetricsQuery] = useState(null)

  const filterInputId = filterInputOpen ? 'simple-popover' : undefined;
  const filterInputId1 = filterInputOpen1 ? 'simple-popover1' : undefined;
  const selectFiltersInput = useRef(null);
  const selectFiltersInput1 = useRef(null);
  const chartSlider = useRef(null);
  const numberValues = ["one", "two", "three", "four", "five"];

  /* useEffect(() => {
    //console.log(sheetsAvailable)
  },[sheetsAvailable]) */

  setLanguage(language)
  let { state } = useLocation();
  if (language) {
    updateLanguage(language)
  }
  else if (state) {
    updateLanguage(state)
  }
  else if (!language && !state) {
    updateLanguage('en')
  }

  const MultiSelectRow = ({ index, style, data }) => {
    const item = data[index];
    return <div style={style} key={item}>
      <FormControlLabel title={item} className="filters-view-checkbox menu-item" label={item}
        control={<Checkbox className="form_checkbox" size="small"
          icon={<CheckBoxIcon />} checkedIcon={<CheckBoxCheckedIcon />}
          checked={selectedSubjects.indexOf(item) > -1}
          value={item}
          onChange={handleSubjectFilterChange} />} />
    </div>
  }

  const MultiSelectRow1 = ({ index, style, data }) => {
    const item = data[index];
    return (
      item.value === "Custom" ?
        <div style={style} key={item}>
          <FormControlLabel title={item} className="menu-item menu-item-light" label={handleLanguageChange(item)}
            control={
              <Radio className="form_checkbox radio_checkbox" size="small"
                checked={selectedPeriod === item}
                value={item}
                onChange={(e) => setSelectedPeriod(e.target.value)}
              />
            }
          />
        </div>
        :
        <div style={style} key={item}>
          <FormControlLabel className="menu-item menu-item-light" label={handleLanguageChange(item)}
            control={
              <Radio className="form_checkbox" size="small"
                checked={selectedPeriod === item}
                value={item}
                onChange={(e) => setSelectedPeriod(e.target.value)}
              />
            }
          />
        </div>
    )
  }

  const getPeriodValueHandler = async (value) => {
    handleFilterInputClose1()
    setLoading(false)
    const { startDate, endDate } = await generateCustomDateRange(value)
    setStartDate(startDate)
    setEndDate(endDate)
    handlePeriodReportFilter(startDate, endDate)
  }

  const handlePeriodReportFilter = async (startDate, endDate) => {
    //console.log('Period Filter')
    let filter = {
      operator: "inDateRange",
      values: [startDate, endDate],
      dataSetType: 'DIMENSION',
      filterType: 'date_filter'
    }
    sheetsAvailable[selectedSheetIndex]?.reports.forEach((report) => {
      //const reportFilter = JSON.parse(JSON.stringify(report?.reportFilters))
      const reportFilter = report?.reportFilters.filter(obj => obj.hasOwnProperty('operator'))
      const dateFilter = reportFilter.findIndex(filter => filter?.filterType === 'date_filter')
      if (dateFilter >= 0) {
        reportFilter.splice(dateFilter, 1)
      }
      let dataSetName = null;
      if (report.dimensions?.length > 0) {
        dataSetName = report.dimensions[0]?.fieldName?.split('.')[0];
      }else if (report.measures?.length > 0) {
        dataSetName = report.measures[0]?.fieldName?.split('.')[0];
      }
      let measureList = report.measuresList
      if (measureList && measureList?.length) {
        let isMeas = measureList.find(meas => meas?.name === 'createDate' || meas?.name === 'assignDate' || meas?.name === 'dateTime' || meas?.name === 'createDateTime')
        if(isMeas){
          let member = `${dataSetName}.${isMeas.name}`
          filter = {member,...filter}
          reportFilter.push(filter)
          report.reportFilters = [...reportFilter]
        }
      }    
      return report
    })
    //console.log(sheetsAvailable)
    let newArray = [...sheetsAvailable];
    //console.log(newArray)
    //console.log(JSON.parse(JSON.stringify(newArray)))
    setSheetsAvailable(JSON.parse(JSON.stringify(newArray)));
    //setUserProfile(currentUser)
    setLoading(false)
    //setSelectedProfile(profiles)
  }

  const clearFilterHandler = () => {
    //console.log('Clear Filter')
    setStartDate("")
    setEndDate("")
    // handleCustomDateFilter()
    handleStartDateReportFilter("", "");
    handleEndDateReportFilter("", "");
    setSelectedPeriod("")
    handleFilterInputClose1()
    sheetsAvailable[selectedSheetIndex]?.reports.forEach((report) => {
      //const reportFilter = JSON.parse(JSON.stringify(report?.reportFilters))
      const reportFilter = JSON.parse(JSON.stringify(report?.reportFilters)).filter(obj => obj.hasOwnProperty('operator'))
      let dateFilterIndex = reportFilter.findIndex(filter => filter?.filterType === 'date_filter')
      if (dateFilterIndex >= 0) {
        reportFilter.splice(dateFilterIndex, 1)
      }
      report.reportFilters = [...JSON.parse(JSON.stringify(reportFilter))]
      return report
    })
    let newArray = [...sheetsAvailable];
    //console.log(JSON.parse(JSON.stringify(newArray)))
    setSheetsAvailable(JSON.parse(JSON.stringify(newArray)));
    //setUserProfile(currentUser)
    //setSelectedProfile(profiles)
  }

  useEffect(() => {
    //console.log(sheetsAvailable,selectedSheetIndex)
    if (sheetsAvailable[selectedSheetIndex] && profiles.length) {
      //console.log('Use Effect')
      let filterArr = {
        operator: 'equals',
        values: profiles.map(p => p?.learningProfileId),
        dataSetType: 'DIMENSION',
        filterType: 'profile_filter'
      }
      let schoolCodeFilterArr = {
        operator: 'equals',
        values: profiles.map(p => p?.schoolCode),
        dataSetType: 'DIMENSION',
        filterType: 'schoolCode_filter'
      }

      let profileIdArr = {
        operator: 'equals',
        values: profiles.map(p => p?.profileId),
        dataSetType: 'DIMENSION',
        filterType: 'profileId_filter'
      }

      sheetsAvailable[selectedSheetIndex]?.reports.map(report => {
        let reportFilter = JSON.parse(JSON.stringify(report?.reportFilters))

        const profileFilter = reportFilter.find(filter => filter?.filterType === 'profile_filter')

        const schoolCodeFilter = reportFilter.find(filter => filter?.filterType === 'schoolCode_filter')

        const profileIdFilter = reportFilter.find(filter => filter?.filterType === 'profileId_filter')

        let dataSetName = null;
        if (report.dimensions?.length > 0) {
          dataSetName = report.dimensions[0]?.fieldName?.split('.')[0];
        }
        else if (report.measures?.length > 0) {
          dataSetName = report.measures[0]?.fieldName?.split('.')[0];
        }

        setLoading(true)

        filterArr.member = `${dataSetName}.learningProfileId`
        if (!profileFilter) {
          reportFilter.push(filterArr)
        }
        else {
          reportFilter = reportFilter.map(obj => {
            if(obj.filterType == 'profile_filter'){
              obj.values = profiles.map(p => p?.learningProfileId)
            }
            return obj
          })
        }

        schoolCodeFilterArr.member = `${dataSetName}.schoolCode`
        if (!schoolCodeFilter) {
          reportFilter.push(schoolCodeFilterArr)
        }
        else {
          reportFilter = reportFilter.map(obj => {
            if(obj.filterType == 'schoolCode_filter'){
              obj.values = profiles.map(p => p?.schoolCode)
            }
            return obj
          })
        }

        profileIdArr.member = `${dataSetName}.profileId`
        if (!profileIdFilter) {
          reportFilter.push(profileIdArr)
        }
        else {
          reportFilter = reportFilter.map(obj => {
            if(obj.filterType == 'profileId_filter'){
              obj.values = [...new Set(profiles.map(p => p?.profileId))]
            }
            return obj
          })
        }
        report.reportFilters = [...JSON.parse(JSON.stringify(reportFilter))]
        return report
      })
      profileIdArr.values = [...new Set(profileIdArr.values)]
      schoolCodeFilterArr.values = [...new Set(schoolCodeFilterArr.values)]
      filterArr.values = [...new Set(filterArr.values)]
      //console.log(profileIdArr,filterArr,schoolCodeFilterArr)
      getCustomQueryData(undefined, { profile: filterArr, schoolCode: schoolCodeFilterArr, profileId: profileIdArr })
      let newArray = [...sheetsAvailable];
      setSheetsAvailable(JSON.parse(JSON.stringify(newArray)));
      setCurrentProfile('all');
      setSelectedProfile(profiles)
      /* if(profiles.length === 1) {
        setSelectedTab(profiles[0]?.profile+'.'+0)
        setSelectedProfile(profiles[0].profile)
      } */

      // setLoading(false)
    }

  }, [profiles])


  const handleProfileChange = async (event, itm) => {
    //console.log('Profile Change')
    setSelectedSubjects([])
    setStartDate(null)
    setEndDate(null)
    setTempFilterState([])


    let indx;
    let profil;
    if (itm) {
      profil = itm.split('.')[0]
      indx = itm.split('.')[1]
    }
    let profile = []
    if (profil === "all") {
      profile = profiles
    }
    else if (profil) {
      const profileObj = profiles.find((ele, index) => ele && ele?.profile === profil && index == indx)
      profile.push(profileObj)
    }

    if (profile.length) {
      getCustomQueryData(profile, null, null, 'profileChange')
      setSelectedProfile(profile)
      getSubjectFilterData(profile)


      let filterArr = {
        operator: 'equals',
        values: profile?.map(p => p?.learningProfileId),
        dataSetType: 'DIMENSION',
        filterType: 'profile_filter'
      }

      let schoolCodeArr = {
        operator: 'equals',
        values: profile?.map(p => p?.schoolCode),
        dataSetType: 'DIMENSION',
        filterType: 'schoolCode_filter'
      }

      let profileIdArr = {
        operator: 'equals',
        values: profile?.map(p => p?.profileId),
        dataSetType: 'DIMENSION',
        filterType: 'profileId_filter'
      }

      sheetsAvailable[selectedSheetIndex]?.reports.map(async report => {
        let reportFilter = JSON.parse(JSON.stringify(report?.reportFilters))
        const profileFilter = reportFilter.find(filter => filter?.filterType === 'profile_filter')
        const schoolCodeFilter = reportFilter.find(filter => filter?.filterType === 'schoolCode_filter')
        const profileIdFilter = reportFilter.find(filter => filter?.filterType === 'profileId_filter')

        let subjectFilterIndex = reportFilter.findIndex(filter => filter?.filterType === 'subject_filter')
        if (subjectFilterIndex >= 0) {
          reportFilter.splice(subjectFilterIndex, 1)
        }

        let dateFilterIndex = reportFilter.findIndex(filter => filter?.filterType === 'date_filter')
        if (dateFilterIndex >= 0) {
          reportFilter.splice(dateFilterIndex, 1)
        }

        let dataSetName = null;
        if (report.dimensions?.length > 0) {
          dataSetName = report.dimensions[0]?.fieldName?.split('.')[0];
        }
        else if (report.measures?.length > 0) {
          dataSetName = report.measures[0]?.fieldName?.split('.')[0];
        }
        // const list = await getMeasuresList({ dataSetId: report?.dataSetId })
        let measureList = []


        if (dataSetMeasureList?.[report?.dataSetId]) {
          measureList = dataSetMeasureList?.[report?.dataSetId]
        }
        else {
          const list = await getMeasuresList({ dataSetId: report?.dataSetId })
          measureList = list?.result

          if (report?.dataSetId)
            dataSetMeasureList[report?.dataSetId] = measureList ?? []
        }


        if (measureList && measureList?.length) {
          const isMeas = measureList.find(meas => meas?.name === 'learningProfileId')
          const isCode = measureList.find(meas => meas?.name === 'schoolCode')
          const isProfId = measureList.find(meas => meas?.name === 'profileId')
          if (isMeas && isCode && isProfId) {
            if (!loading) {
              setLoading(true)
            }
            filterArr.member = `${dataSetName}.${isMeas?.name}`
            schoolCodeArr.member = `${dataSetName}.${isCode?.name}`
            profileIdArr.member = `${dataSetName}.${isProfId?.name}`
            if (!profileFilter) {
              reportFilter.push(filterArr)
            }
            else {
              reportFilter = reportFilter.map(obj => {
                if(obj.filterType == 'profile_filter'){
                  obj.values = profile.map(p => p?.learningProfileId)
                }
                return obj
              })
            }

            if (!schoolCodeFilter) {
              reportFilter.push(schoolCodeArr)
            }
            else {
              reportFilter = reportFilter.map(obj => {
                if(obj.filterType == 'schoolCode_filter'){
                  obj.values = profile.map(p => p?.schoolCode)
                }
                return obj
              })
              //schoolCodeFilter.values = profile?.map(p => p?.schoolCode)
            }

            if (!profileIdFilter) {
              reportFilter.push(profileIdArr)
            }
            else {
              //profileIdFilter.values = profile?.map(p => p?.profileId)
              reportFilter = reportFilter.map(obj => {
                if(obj.filterType == 'profileId_filter'){
                  obj.values = [...new Set(profile.map(p => p?.profileId))]
                }
                return obj
              })
            }
          }
        }
        report.reportFilters = [...JSON.parse(JSON.stringify(reportFilter))]
        return report
      })

      let newArray = [...sheetsAvailable];
      setSheetsAvailable(JSON.parse(JSON.stringify(newArray)));
      setCurrentProfile(profil);
      setSelectedTab(itm)
      setLoading(false)
    }

  };

  const windowResized = () => {

    if (window.innerWidth < 400) {
      setCarousalCards(2);
      setChevronVisibility(false);
    } else if (window.innerWidth < 639) {
      setCarousalCards(2);
      setChevronVisibility(false);
    } else if (window.innerWidth < 1200) {
      setCarousalCards(3);
      setChevronVisibility(true);
    } else {
      setCarousalCards(4);
      setChevronVisibility(true);
    }

    if (window.innerWidth < 600) {
      setCarousalWidth(window.innerWidth - 40);
    } else {
      setCarousalWidth('100%');
    }

  }

  useEffect(() => {
    windowResized();
    window.addEventListener('resize', windowResized);
    let userAgent = navigator.userAgent;
    const parser = new UAParser();
    parser.setUA(userAgent);
    const result = parser.getResult();
    const deviceTypeParser = (result.device && result.device.type) || "desktop";
    setDeviceType(deviceTypeParser);

    /* if (!currentUser && localStorage.getItem('uuid')) {
      currentUser = DecryptData(localStorage.getItem('uuid'))
      setCurrentUser(currentUser)
    } */
    if (!currentUser && localStorage.getItem('t_uuid')) {
      currentUser = DecryptData(localStorage.getItem('t_uuid'))
      setCurrentUser(JSON.parse(currentUser))
    }
    else if (!currentUser && localStorage.getItem('s_uuids')) {
      currentUser = DecryptData(localStorage.getItem('s_uuids'))
      setCurrentUser(JSON.parse(currentUser))
    }
    else if (!currentUser && localStorage.getItem('emUserId')) {
      currentUser = DecryptData(localStorage.getItem('emUserId'))
      setCurrentUser(currentUser)
    }

    //getSubjectIconData()
    fetchDashboardDetails();
    if (studentId) getCustomQueryData()

  }, []);

  React.useLayoutEffect(() => {
    document.body.classList.add("embed-reports-page");
    if (window.self != window.top) {
      document.body.classList.add("embed-reports-page-iframe");
    }
  }, []);


  const setUserProfile = async (s_uuid) => {
    //console.log('Set User Profile')
    s_uuid = studentId ? studentId : s_uuid
    if (s_uuid) {
      //console.log(s_uuid)
      let dataSetName = STUDENT_PROFILE_DATASET
      let uuid = (typeof s_uuid === 'string') ? (s_uuid == 'superadmin' || s_uuid == 'superadmin@extramarks.com'? '':s_uuid) : ''
      const filters = [{ member: `${dataSetName}.status`, operator: 'equals', values: ["1"] }]
      if(uuid){
        filters.push({ member: `${dataSetName}.uuid`, operator: 'equals', values: [uuid] })
      }
      const members = [`${dataSetName}.profileName`, `${dataSetName}.schoolCode`, `${dataSetName}.learningProfileId`, `${dataSetName}.learningProfile`, `${dataSetName}.profileId`, `${dataSetName}.avatarId`]

      setLoading(true)

      const data = await getDataFromCube('limit', undefined, filters, "static_dashboard", members);

      if (data?.length && Object.keys(data[0]).length) {
        const profileData = data.map(ele => {
          return {
            profile: ele[`${dataSetName}.profileName`],
            profileId: ele[`${dataSetName}.profileId`],
            learningProfileId: ele[`${dataSetName}.learningProfileId`],
            schoolCode: ele[`${dataSetName}.schoolCode`],
            avatarId: ele[`${dataSetName}.avatarId`],
            learningProfile: ele[`${dataSetName}.learningProfile`]
          }
        })
        setProfiles(profileData)
        //setLoading(false)
        // getSubjectFilterData(profileData)
        const learningData = await getDataFromCube('limit', undefined, filters, "static_dashboard", [`${dataSetName}.profileName`,`${dataSetName}.learningProfile`]);
        if (learningData?.length && Object.keys(learningData[0]).length) {
          const learningProfileMappedArr = learningData.map(ele => {
            return {
              profileName: ele[`${dataSetName}.profileName`],
              learningProfile: ele[`${dataSetName}.learningProfile`]
            }
          })
          //console.log(learningProfileMappedArr)
          setLearningProfileMapping(learningProfileMappedArr)
        }
        
      }
      else {
        getCustomQueryData()
        setProfiles([])
        //setLoading(false)
      }
    }
  }


  const getSubjectFilterData = async (profileData) => {
    let dataSetName = STUDENT_PROFILE_DATASET
    let learningProileList = profileData.map(p => p?.learningProfileId)
    let profileList = profileData.map(p => p?.profileId)
    const filters = [{ member: `${settings.LEARN_ACTIVITY_LOG_DATASET}.subject`, operator: 'notEquals', values: ['None'] }, { member: `${settings.LEARN_ACTIVITY_LOG_DATASET}.subject`, "operator": "set" }
    ]
    if(learningProileList.length > 0){
      filters.push({ member: `${settings.LEARN_ACTIVITY_LOG_DATASET}.learningProfileId`, operator: 'equals', values:learningProileList  })
    }
    if(profileList.length > 0){
      filters.push({ member: `${settings.LEARN_ACTIVITY_LOG_DATASET}.profileId`, operator: 'equals', values: profileList })
    }


    const members = `${settings.LEARN_ACTIVITY_LOG_DATASET}.subject`
    setSubjectsLoader(true)

    return getDataFromCube(undefined, undefined, filters, "static_dashboard", members)
      .then(data => {
        setSubjectsLoader(false)

        if (data?.length) {
          let subjectList = data.map(d => d[`${settings.LEARN_ACTIVITY_LOG_DATASET}.subject`])
          setSubjectFilterData(subjectList)
        }
        else {
          setSubjectFilterData([])
        }
      })
      .catch(err => {
        setSubjectsLoader(false)
      })

  }

  const useStyles = makeStyles((theme) => ({
    fieldMenu: {
      boxShadow: '0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)',
    },
    fieldBtn: {
      position: 'absolute',
      right: '5px',
      bottom: '3px',
      cursor: 'pointer',
    },
    reportFieldList: {
      width: '100%',
      backgroundColor: '#fff',
      maxHeight: '350px',
      minHeight: '350px',
      marginBottom: '1rem',
      boxShadow: '0px 3px 6px #00000029',
      overflow: 'auto',
      marginTop: '5px',
      borderRadius: '4px',
    },
    bgWhite: {
      backgroundColor: '#fff',
      borderRadius: '4px',
    },
    reportGraphs: {
      height: 'fit-content',
      minHeight: '500px',
      height: '100%',
      borderRadius: '8px',
    },
    reportsSelectFilter: {
      background: "#000",
      '&:hover': {
        background: "#f1f1f1",
      },
      '&.MuiFormLabel-root.Mui-focused': {
        color: 'red',
      },
    },
    reportContentWrapper: {
      padding: '0rem',
      marginTop: '0rem',
      [theme.breakpoints.down('lg')]: {
        padding: '0rem',
      },
      ['@media (max-width:1400px)']: {
        padding: '0rem',
      }
    },
    searchFieldListItem: {
      paddingTop: '0.6rem',
      paddingBottom: '0.6rem',
      '&:hover': {
        background: "#f1f1f1",
        zIndex: 9,
      },
    }

  }));
  const classes = useStyles()

  const containerRef = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);
  const [reportsList, setReportsList] = useState([])

  const handleCustomDateFilter = (query, type = undefined, queryType) => {
    //console.log(type,query,queryType)
    let filter;
    let clonedStartDate = _.clone(startDate)
    let clonedEndDate = _.clone(endDate)

    if (queryType === 'profileChange') {
      clonedStartDate = null
      clonedEndDate = null
    }


    if (clonedStartDate && clonedEndDate) {
      filter = {
        operator: "inDateRange",
        values: [clonedStartDate, clonedEndDate],
      }
    }
    else if (clonedStartDate && !clonedEndDate) {
      filter = {
        operator: "afterDate",
        values: [clonedStartDate],
      }
    }
    else if (!clonedStartDate && clonedEndDate) {
      filter = {
        operator: "beforeDate",
        values: [clonedEndDate],
      }
    }
    else {
      filter = {}
    }
    // }

    let dataSetName = query?.dimensions?.length ? query?.dimensions?.[0].split('.')[0] : query?.measures[0].split('.')[0];

    if (filter) {
      if (query && query?.filters?.length) {
        let exist = query?.filters.find(filter => filter?.member.split('.')[1] === 'createDate' || filter?.member.split('.')[1] === 'createDatetime' || filter?.member.split('.')[1] === 'dateTime');


        if (exist) {
          exist.operator = filter?.operator;
          exist.values = filter?.values
        }
        else {
          filter.member = `${dataSetName}.${type === 'progressReport' ? 'createDate' : type === 'attendance' ? 'createDate' : 'dateTime'}`
          query?.filters.push(filter)
        }
      }
      else {
        filter.member = `${dataSetName}.${type === 'progressReport' ? 'createDate' : type === 'attendance' ? 'createDate' : 'dateTime'}`
        query?.filters.push(filter)
      }

    }


    if (!filter?.operator) {
      let DateFilterIndex = query?.filters.findIndex(filter => filter?.member.split('.')[1] === 'createDate' || filter?.member.split('.')[1] === 'createDatetime' || filter?.member.split('.')[1] === 'dateTime');
      if (DateFilterIndex > -1) {
        query?.filters?.splice(DateFilterIndex, 1)
      }
    }


    if (query?.filters.length) {
      let queryFilter = query?.filters.filter(f => (f && f?.member && f?.operator && f?.values && f?.values?.length))
      query.filters = queryFilter
    }
    //console.log(type,query)
    return query
  }

  const formatCustomData = (data) => {
    data.forEach(ele => {
      if (Object.keys(ele).length) {
        Object.keys(ele).forEach(k => {
          if (!ele[k]) {
            ele[k] = 0
          }
        })
      }
    })
    return data
  }

  let handleCustomDataFilter = (query, type, queryType) => {
    let dataSetName = query?.dimensions?.length ? query?.dimensions?.[0].split('.')[0] : query?.measures[0].split('.')[0];

    let clonedSelectedSubjects = _.cloneDeep(selectedSubjects)
    if (queryType === 'profileChange') {
      clonedSelectedSubjects = []
    }

    if (query && query?.filters?.length) {
      let exist = query?.filters.find(filter => (filter?.member.split('.')[1] === 'subject' || filter?.member.split('.')[1] === 'subject') && filter?.operator === 'equals');
      if (exist) {
        exist.values = clonedSelectedSubjects
      }
      else {
        query?.filters.push({
          member: `${dataSetName}.${type === 'progressReport' ? 'subject' : 'subject'}`,
          operator: 'equals',
          values: clonedSelectedSubjects
        })
      }
    }
    else {
      query?.filters.push({
        member: `${dataSetName}.${type === 'progressReport' ? 'subject' : 'subject'}`,
        operator: 'equals',
        values: clonedSelectedSubjects
      })
    }


    if (query?.filters.length) {
      let queryFilter = query?.filters.filter(f => (f && f?.member && f?.operator && f?.values && f?.values?.length))
      query.filters = queryFilter
    }

    return query
  }

  const handleCustomProfileDataFilter = (query, type, profile, defaultProfile) => {

    let dataSetName = query?.dimensions?.length ? query?.dimensions?.[0].split('.')[0] : query?.measures[0].split('.')[0];
    if (defaultProfile) {
      let obj = {
        member: `${dataSetName}.learningProfileId`,
        operator: 'equals',
        values: defaultProfile?.profile?.values
      }
      let codeObj = {
        member: `${dataSetName}.schoolCode`,
        operator: 'equals',
        values: defaultProfile?.schoolCode?.values
      }
      let profileIdObj = {
        member: `${dataSetName}.profileId`,
        operator: 'equals',
        values: defaultProfile?.profileId?.values
      }
      query?.filters.push(obj)
      query?.filters.push(codeObj)
      query?.filters.push(profileIdObj)
    }
    else if (profile && !profile.includes(undefined)) {

      if (query && query?.filters?.length) {
        let exist = query?.filters.find(filter => filter?.member.split('.')[1] === 'learningProfileId');

        let profileIdExist = query?.filters.find(filter => filter?.member.split('.')[1] === 'profileId');

        let codeExist = query?.filters.find(filter => filter?.member.split('.')[1] === 'schoolCode');

        if (exist) {
          exist.values = profile.map(p => p?.learningProfileId)
        }
        else {
          query?.filters.push({
            member: `${dataSetName}.learningProfileId`,
            operator: 'equals',
            values: profile.map(p => p?.learningProfileId)
          })
        }

        if (codeExist) {
          codeExist.values = profile.map(p => p?.schoolCode)
        }
        else {
          query?.filters.push({
            member: `${dataSetName}.schoolCode`,
            operator: 'equals',
            values: profile.map(p => p?.schoolCode)
          })
        }

        if (profileIdExist) {
          profileIdExist.values = profile.map(p => p?.profileId)
        }
        else {
          query?.filters.push({
            member: `${dataSetName}.profileId`,
            operator: 'equals',
            values: profile.map(p => p?.profileId)
          })
        }

      }
      else {
        query?.filters.push({
          member: `${dataSetName}.learningProfileId`,
          operator: 'equals',
          values: profile.map(p => p?.learningProfileId)
        })

        query?.filters.push({
          member: `${dataSetName}.schoolCode`,
          operator: 'equals',
          values: profile.map(p => p?.schoolCode)
        })

        query?.filters.push({
          member: `${dataSetName}.profileId`,
          operator: 'equals',
          values: profile.map(p => p?.profileId)
        })
      }


      if (query?.filters.length) {
        let queryFilter = query?.filters.filter(f => (f && f?.member && f?.operator && f?.values && f?.values?.length))
        query.filters = queryFilter
      }

    }
    return query

  }

  const getCustomQueryData = async (profile = undefined, defaultProfile = undefined, dateObj = undefined, type = undefined) => {
    let { highestPerformance, leastPerformance, overAllAccuracy, overAllAttendance, keyTimePerformanceMetrics, keyMarksPerformanceMetrics } = STUDENT_DASHBOARD_QUERY
    let { highestPerform, leastPerform, Accuracy_Perc, overAllAtten, totalTimeMinute } = STUDENT_DASHBOARD_CALCULATED_FIELDS
    let newStatistics = [...statistics];
    let timePerformanceMetrics = STUDENT_DASHBOARD_QUERY?.keyTimePerformanceMetrics
    timePerformanceMetrics = handleCustomDataFilter(timePerformanceMetrics, "progressReport")
    timePerformanceMetrics = handleCustomProfileDataFilter(timePerformanceMetrics, "progressReport")
    timePerformanceMetrics = handleCustomDateFilter(timePerformanceMetrics, 'progressReport')
    let keyTimeMetricsQuery = timePerformanceMetrics
    //let [keyTimeMetricsQuery, setKeyTimeMetricsQuery] = useState(timePerformanceMetrics)

    let marksPerformanceMetrics = STUDENT_DASHBOARD_QUERY?.keyMarksPerformanceMetrics
    marksPerformanceMetrics = handleCustomDataFilter(marksPerformanceMetrics, settings.STUDENT_ASSESSMENT_DATASET)
    marksPerformanceMetrics = handleCustomProfileDataFilter(marksPerformanceMetrics, settings.STUDENT_ASSESSMENT_DATASET)
    marksPerformanceMetrics = handleCustomDateFilter(marksPerformanceMetrics, undefined) 
    let keyMarksMetricsQuery = marksPerformanceMetrics
    //let [keyMarksMetricsQuery, setKeyMarksMetricsQuery] = useState(marksPerformanceMetrics)
    setLoading(true)
    //High Performing
    let highestPerformanceQuery = highestPerformance
    highestPerformanceQuery = handleCustomProfileDataFilter(highestPerformanceQuery, settings.STUDENT_ASSESSMENT_DATASET, profile, defaultProfile)

    let data11
    // let data11 = getDataFromCube(undefined, undefined, undefined, "custom_query_data", highestPerformanceQuery);

    // Least Performing
    let leastPerformanceQuery = leastPerformance
    // leastPerformanceQuery = handleCustomDataFilter(leastPerformanceQuery)
    leastPerformanceQuery = handleCustomProfileDataFilter(leastPerformanceQuery, settings.STUDENT_ASSESSMENT_DATASET, profile, defaultProfile)
    // leastPerformanceQuery = handleCustomDateFilter(leastPerformanceQuery, undefined, dateObj)
    let data22
    // let data22 = getDataFromCube(undefined, undefined, undefined, "custom_query_data", leastPerformanceQuery);

    //Over All Accuracy

    let overAllAccuracyQuery = overAllAccuracy
    // overAllAccuracyQuery = handleCustomDataFilter(overAllAccuracyQuery)
    overAllAccuracyQuery = handleCustomProfileDataFilter(overAllAccuracyQuery, settings.STUDENT_ASSESSMENT_DATASET, profile, defaultProfile)
    // overAllAccuracyQuery = handleCustomDateFilter(overAllAccuracyQuery, undefined, dateObj)
    let data33
    // let data33 = getDataFromCube(undefined, undefined, undefined, "custom_query_data", overAllAccuracyQuery);


    //OverAll Attendance 
    let overAllAttendanceQuery = overAllAttendance
    // overAllAttendanceQuery = handleCustomDataFilter(overAllAttendanceQuery)
    overAllAttendanceQuery = handleCustomProfileDataFilter(overAllAttendanceQuery, "attendance", profile, defaultProfile)
    // overAllAttendanceQuery = handleCustomDateFilter(overAllAttendanceQuery, 'attendance', dateObj)

    let data44
    // let data44 = getDataFromCube(undefined, undefined, undefined, "custom_query_data", overAllAttendanceQuery);


    ///Key Areas ///

    // let timePerformanceMetrics = keyTimePerformanceMetrics

    timePerformanceMetrics = _.cloneDeep(keyTimeMetricsQuery)
    timePerformanceMetrics = handleCustomDataFilter(timePerformanceMetrics, "progressReport", type)
    timePerformanceMetrics = handleCustomProfileDataFilter(timePerformanceMetrics, "progressReport", profile, defaultProfile)
    timePerformanceMetrics = handleCustomDateFilter(timePerformanceMetrics, 'progressReport', type)
    setKeyTimeMetricsQuery(timePerformanceMetrics)

    let data55 = ''
    // let data55 = getDataFromCube(undefined, undefined, undefined, "custom_query_data", timePerformanceMetrics);


    marksPerformanceMetrics = _.cloneDeep(keyMarksMetricsQuery)
    marksPerformanceMetrics = handleCustomDataFilter(marksPerformanceMetrics, settings.STUDENT_ASSESSMENT_DATASET, type)
    marksPerformanceMetrics = handleCustomProfileDataFilter(marksPerformanceMetrics, settings.STUDENT_ASSESSMENT_DATASET, profile, defaultProfile)
    marksPerformanceMetrics = handleCustomDateFilter(marksPerformanceMetrics, undefined, type)
    setKeyMarksMetricsQuery(marksPerformanceMetrics)


    let data66 = ''
    // let data66 = getDataFromCube(undefined, undefined, undefined, "custom_query_data", marksPerformanceMetrics);

    //Getting all Static Data Response
    const allResp = [[]]

    if (allResp?.length) {
      //High performance
      let data1 = allResp[0]
      if (data1?.length) {


        data1 = formatCustomData(data1)
        const perfData = data1.filter(d => d && d[highestPerform] && d[highestPerform] !== 'NaN')?.[0]

        if (perfData && Object.keys(perfData).length) {
          let exist = newStatistics.find(st => st?.title === 'High Performing')
          if (exist) {
            exist.data = Math.round(perfData[highestPerform], 2)
            exist.label = perfData[`${settings.STUDENT_ASSESSMENT_DATASET}.subject`]
            exist.query = highestPerformanceQuery

          }
          else {
            newStatistics.push({
              title: 'High Performing',
              data: Math.round(perfData[highestPerform], 2),
              label: perfData[`${settings.STUDENT_ASSESSMENT_DATASET}.subject`],
              query: highestPerformanceQuery
            })
          }
        } else {
          let exist = newStatistics.find(st => st?.title === 'High Performing')
          if (exist) {
            exist.data = 0
            exist.label = ''
            exist.query = highestPerformanceQuery

          } else {
            newStatistics.push({
              title: 'High Performing',
              data: 0,
              label: '',
              query: highestPerformanceQuery

            })
          }

        }
      }
      else {
        let exist = newStatistics.find(st => st?.title === 'High Performing')
        if (exist) {
          exist.data = 0
          exist.label = ''
          exist.query = highestPerformanceQuery
        } else {
          newStatistics.push({
            title: 'High Performing',
            data: 0,
            label: '',
            query: highestPerformanceQuery

          })
        }
      }

      //Least Performing
      let data2 = allResp[1]
      if (data2?.length) {
        data2 = formatCustomData(data2)
        const perfData = data2.filter(d => d && d[leastPerform] && d[leastPerform] !== 'NaN')?.[0]

        if (perfData && Object.keys(perfData).length) {
          let exist = newStatistics.find(st => st?.title === 'Least Performing')
          if (exist) {
            exist.data = Math.round(perfData[leastPerform], 2)
            exist.label = perfData[`${settings.STUDENT_ASSESSMENT_DATASET}.subject`]
            exist.query = leastPerformanceQuery
          }
          else {
            newStatistics.push({
              title: 'Least Performing',
              data: Math.round(perfData[leastPerform], 2),
              label: perfData[`${settings.STUDENT_ASSESSMENT_DATASET}.subject`],
              query: leastPerformanceQuery
            })
          }
        }
        else {
          let exist = newStatistics.find(st => st?.title === 'Least Performing')
          if (exist) {
            exist.data = 0
            exist.label = ''
            exist.query = leastPerformanceQuery

          } else {
            newStatistics.push({
              title: 'Least Performing',
              data: 0,
              label: '',
              query: leastPerformanceQuery
            })
          }
        }
      }
      else {
        let exist = newStatistics.find(st => st?.title === 'Least Performing')
        if (exist) {
          exist.data = 0
          exist.label = ''
          exist.query = leastPerformanceQuery

        } else {
          newStatistics.push({
            title: 'Least Performing',
            data: 0,
            label: '',
            query: leastPerformanceQuery
          })
        }
      }



      //Overall Accuracy
      let data3 = allResp[2]
      if (data3?.length) {
        data3 = formatCustomData(data3)
        const perfData = data3.filter(d => d && d[Accuracy_Perc] && d[Accuracy_Perc] !== 'NaN')?.[0]

        if (perfData && Object.keys(perfData).length) {
          let exist = newStatistics.find(st => st?.title === 'Overall Accuracy')
          if (exist) {
            exist.data = Math.round(perfData[Accuracy_Perc], 2)
            exist.label = 'Accuracy'
            exist.query = overAllAccuracyQuery

          } else {
            newStatistics.push({
              title: 'Overall Accuracy',
              data: Math.round(perfData[Accuracy_Perc], 2),
              label: 'Accuracy',
              query: overAllAccuracyQuery
            })
          }
        }
        else {
          let exist = newStatistics.find(st => st?.title === 'Overall Accuracy')
          if (exist) {
            exist.data = 0
            exist.label = 'Accuracy'
            exist.query = overAllAccuracyQuery
          } else {
            newStatistics.push({
              title: 'Overall Accuracy',
              data: 0,
              label: 'Accuracy',
              query: overAllAccuracyQuery
            })
          }
        }

      } else {
        let exist = newStatistics.find(st => st?.title === 'Overall Accuracy')
        if (exist) {
          exist.data = 0
          exist.label = 'Accuracy'
          exist.query = overAllAccuracyQuery
        } else {
          newStatistics.push({
            title: 'Overall Accuracy',
            data: 0,
            label: 'Accuracy',
            query: overAllAccuracyQuery

          })
        }
      }


      //OverAll Attendance
      let data4 = allResp[3]
      if (data4?.length) {
        data4 = formatCustomData(data4)
        const perfData = data4.filter(d => d && d[overAllAtten] && d[overAllAtten] !== 'NaN')?.[0]
        if (perfData && Object.keys(perfData).length) {
          let exist = newStatistics.find(st => st?.title === 'Overall Attendance')
          if (exist) {
            exist.data = Math.round(perfData[overAllAtten], 2)
            exist.label = 'Attendance'
            exist.query = overAllAttendanceQuery
          } else {
            newStatistics.push({
              title: 'Overall Attendance',
              data: Math.round(perfData[overAllAtten], 2),
              label: 'Attendance',
              query: overAllAttendanceQuery
            })
          }
        }
        else {
          let exist = newStatistics.find(st => st?.title === 'Overall Attendance')
          if (exist) {
            exist.data = 0
            exist.label = 'Attendance'
            exist.query = overAllAttendanceQuery
          } else {
            newStatistics.push({
              title: 'Overall Attendance',
              data: 0,
              label: 'Attendance',
              query: overAllAttendanceQuery
            })
          }
        }

      } else {
        let exist = newStatistics.find(st => st?.title === 'Overall Attendance')
        if (exist) {
          exist.data = 0
          exist.label = 'Attendance'
          exist.query = overAllAttendanceQuery
        } else {
          newStatistics.push({
            title: 'Overall Attendance',
            data: 0,
            label: 'Attendance',
            query: overAllAttendanceQuery
          })
        }
      }

      setStatstics(newStatistics)

      //keyAreas 1
      let data5 = allResp[4]
      if (data5?.length) {
        data5 = formatCustomData(data5)

        let keyAreaStats1 = data5.sort((a, b) => a[totalTimeMinute] - b[totalTimeMinute]).map(ele => {
          return {
            subject: ele[`${settings.PROGRESS_REPORT_DATASET}.subject`],
            time: ele[totalTimeMinute]
          }
        })
        setNoDataKeyArea1(false)
        setKeyAreas1(keyAreaStats1)
      }
      else {
        setKeyAreas1([])
        setNoDataKeyArea1(true)
      }

      //KeyAreas 2
      let data6 = allResp[5]
      if (data6?.length) {
        data6 = formatCustomData(data6)
        let keyAreaStats2 = data6.map(ele => {
          return {
            subject: ele[`${settings.STUDENT_ASSESSMENT_DATASET}.subject`],
            time: Math.round(ele[leastPerform], 2)
          }
        })
        setNoDataKeyArea2(false)
        setKeyAreas2(keyAreaStats2)
      }
      else {
        setKeyAreas2([])
        setNoDataKeyArea2(true)

      }
    }
    setLoading(false)
  }



  const storeMeasures = async (reportsList, mappedSheets) => {
    let ClonedReportsList = _.cloneDeep(reportsList)

    for (let index = 0; index < ClonedReportsList.length; index++) {
      let reportObj = ClonedReportsList[index]

      //   if (!GlobalMeasuresList[reportObj?.dataSetId]) {
      const list = await getMeasuresList({ dataSetId: reportObj?.dataSetId })
      if (list?.result) {
        reportObj['measuresList'] = list?.result
        // }
      }
      if (reportObj?.linkedReports && reportObj?.linkedReports.length) {
        for (let linked of reportObj?.linkedReports) {
          let report = linked?.reportId
          const list = await getMeasuresList({ dataSetId: report?.dataSetId })
          if (list?.result) {
            report['measuresList'] = list?.result
          }
        }
      }
    }
    mappedSheets[0]['reports'] = ClonedReportsList
    return ClonedReportsList
  }



  const fetchDashboardDetails = async () => {

    getDashboarDetails({ dashboardId: STUDENT_DASHBOARD_ID }).then((res) => {
      // if (!res?.result?.isPublished) return;
      //console.log('Fetch Dashboard')
      let mappedSheets = res?.result?.sheets.map((sheet) => {
        sheet.reports = sheet.reports.map((reportDetails) => {
          reportDetails.label = reportDetails?.reportId?.reportName;
          reportDetails.value = reportDetails?.reportId?._id;
          reportDetails = { ...reportDetails?.reportId, ...reportDetails };
          reportDetails.reportId = reportDetails?.reportId?._id;
          // reportDetails.linkedReports = mapLinkedResponseData(reportDetails)

          return reportDetails;
        });
        return sheet;
      });


      let sheetsWithoutReference = _.cloneDeep(mappedSheets);
      let { reports, sheetGranularities } = sheetsWithoutReference[0]

      let reportWithGranularity = reports?.map(reportObj => {
        let internalPromises = sheetGranularities?.map(async granularity => {
          let { dimension } = granularity
          let dimensionKey = dimension?.split('.')?.[1]
          let measureExistInDataset = await findMeasureByNameAndDataSetId({ dataSetId: reportObj.dataSetId, measureName: dimensionKey })

          if (measureExistInDataset?.exist) {
            let { dataSetId } = measureExistInDataset?.result
            granularity.dimension = `${dataSetId.dataSetName}.${dimensionKey}`
            reportObj.timeDimensions = _.cloneDeep([granularity])
            return reportObj
          }
        })

        if (internalPromises) {
          return Promise.all(internalPromises)
        }
      })

      let StoreDatasetMeasuresPromises = storeMeasures(reports, sheetsWithoutReference)

      return Promise.all([...reportWithGranularity, StoreDatasetMeasuresPromises])
        .then(response => {
          setSheetsAvailable(sheetsWithoutReference);
          setUserProfile(currentUser)
        })
    });

  }

  const handleSelectAllSubjects = () => {
    let clonedSubjectsArray = _.clone(subjectFilterData)
    setSelectedSubjects(clonedSubjectsArray)
  }

  const handleUnSelectAllSubjects = () => {
    setSelectedSubjects([])
    setDisabledProp(true)
  }

  const applyFilterOnReports = async () => {
    //console.log('Apply Filter on Report')
    setDisabledProp(false)
    getCustomQueryData();
    let tempState = selectedSubjects
    setTempFilterState(tempState);
    handleFilterInputClose(null, "applyFilter")
    let filterArr = {
      operator: 'equals',
      values: selectedSubjects,
      dataSetType: 'DIMENSION',
      filterType: 'subject_filter'
    }

    sheetsAvailable[selectedSheetIndex]?.reports.map(report => {
      const reportFilter = JSON.parse(JSON.stringify(report?.reportFilters))
      let dataSetName = null;
      if (report.dimensions?.length > 0) {
        dataSetName = report.dimensions[0]?.fieldName?.split('.')[0];
      }
      else if (report.measures?.length > 0) {
        dataSetName = report.measures[0]?.fieldName?.split('.')[0];
      }

      let subjectFilter;
      subjectFilter = reportFilter.find(f => f?.member === (dataSetName + '.' + 'subject') && f?.operator === 'equals')
      if (!subjectFilter) {
        subjectFilter = reportFilter.find(filter => filter?.filterType === 'subject_filter')
      }

      let measureList = report.measuresList

      if (measureList && measureList?.length) {
        const isMeas = measureList.find(meas => meas?.name === 'subject')
        if (isMeas) {
          setLoading(true)
          filterArr.member = `${dataSetName}.${isMeas?.name}`
          if (!subjectFilter) {
            reportFilter.push(filterArr)
            report.reportFilters = [...JSON.parse(JSON.stringify(reportFilter))]
          }
          else {
            let selected = [...selectedSubjects]
            subjectFilter.values = Array.from(selected)
          }
        }
      }
      report.reportFilters = [...JSON.parse(JSON.stringify(reportFilter))]
      return report
    })

    let newArray = [...sheetsAvailable];
    setSheetsAvailable(JSON.parse(JSON.stringify(newArray)));
    setLoading(false)
  }

  const handleSubjectFilterChange = (e) => {

    const value = e?.target?.value
    const exist = selectedSubjects.find(ele => ele === value)
    if (exist) {
      let newSelected = selectedSubjects.filter(ele => ele !== value)
      if (!newSelected.length) {
        setDisabledProp(true)
      }
      else {
        setDisabledProp(false)
      }
      setSelectedSubjects(newSelected)
    }
    else {
      let newSelected = [...selectedSubjects]
      newSelected.push(value)
      setSelectedSubjects(newSelected)
    }

    if (!tempFilterState.length) {
      setDisabledProp(false)
    }
  }

  const parseValueListFromReport = (sheets) => {
    let FilterValuesList = []
    sheets[selectedSheetIndex]?.sheetFilter?.map(filterObj => {
      FilterValuesList.push(filterObj?.values)
    })
    setValueList(FilterValuesList)
  }


  const setFilterOptionsHandler = (sheets) => {
    let FilterOptionsList = []
    sheets[selectedSheetIndex]?.reports?.map(filterObj => {
      FilterOptionsList.push({
        report: filterObj,
        filterOptionList: filterObj?.reportFilters,
      })
    })

    setFilterOptions(FilterOptionsList)
  }



  const onLayoutChange = (layoutChange) => {
    let SheetLayout = Array.from(layout)
    SheetLayout[selectedSheetIndex] = layoutChange

    if (sheetsAvailable[selectedSheetIndex]?.reports) {
      sheetsAvailable[selectedSheetIndex].reports = sheetsAvailable[selectedSheetIndex]?.reports?.map((reportDetails, i) => {
        reportDetails.reportId = reportDetails?._id

        if (layoutChange && layoutChange[i])
          reportDetails = { ...reportDetails, ...layoutChange[i] }

        return reportDetails
      })
    }

    setLayout(SheetLayout);
  };

  const handleProfileReportIds = () => {
    //console.log(learningProfileMapping)
    setshowKeyMarksPerformance(true)
    setshowKeyTimePerformance(true)
    const reportIds = []
    let learningProf = []
    if (learningProfileMapping.length && selectedProfile && selectedProfile?.length) {
      learningProfileMapping.forEach(prof => {
        const exist = selectedProfile.find(p => p?.profile === prof?.profileName)
        if (exist) {
          if (learningProf?.length) {
            if (!learningProf.find(p => p && p?.profile === exist?.profile))
              learningProf.push({ profile: prof?.learningProfile })
          }
          else {
            learningProf.push({ profile: prof?.learningProfile })
          }
        }
      })
    }

    if (learningProf.length && selectedProfile && selectedProfile.length) {
      for (let selected of learningProf) {
        for (let prof of settings.profileReports) {
          if (prof?.profileName && prof?.profileName.includes(selected?.profile)) {
            reportIds.push(...prof?.reportId)
          }
        }
      }
    }
    setProfileReportIds(reportIds);    
  }


  useEffect(() => {
    //console.log(selectedProfile)
    handleProfileReportIds()
    // getSubjectFilterData(selectedProfile)
  }, [selectedProfile])

  const handleSelectReport = (value) => {
    if (sheetsAvailable[selectedSheetIndex]?.reports) {
      //console.log('Select Report')
      let newArray = Array.from(sheetsAvailable)
      let SheetIndex = newArray[selectedSheetIndex]?.reports?.findIndex(itm => itm._id === value._id)

      if (SheetIndex < 0) {
        newArray[selectedSheetIndex].reports.push(value)
      }
      else {
        newArray[selectedSheetIndex].reports.splice(SheetIndex, 1)
      }

      setSheetsAvailable(JSON.parse(JSON.stringify(newArray)))
      saveDashboardHaveChanges()
    }
  }

  const updateReportsList = (data) => {
    //console.log('Handle Report Updte',data)
    setReportsList(data)
  }

  const saveDashboardHaveChanges = () => {
    let DashboardHaveUnsavedChanges = localStorage.getItem('DashboardHaveUnsavedChanges')
    if (DashboardHaveUnsavedChanges !== 'true' || DashboardHaveUnsavedChanges !== true) {
      localStorage.setItem('DashboardHaveUnsavedChanges', true)
    }
  }

  const handleFilterInputClick = (event) => {
    if (!subjectFilterData?.length) {
      //Subjects will be fetched only if not in state and on clicking on select subject dropdown
      getSubjectFilterData(selectedProfile)
    }
    setSelectFilterWidth(selectFiltersInput.current.clientWidth);
    if (event.currentTarget != filterInputEl) setFilterInputEl(event.currentTarget);
    if (!filterInputOpen) setFilterInputOpen(true);
  };

  const handleFilterInputClick1 = (event) => {
    setSelectFilterWidth(selectFiltersInput.current.clientWidth);
    if (event.currentTarget != filterInputEl1) setFilterInputEl1(event.currentTarget);
    if (!filterInputOpen1) setFilterInputOpen1(true);
  };

  const handleFilterInputClose = (e, type) => {
    if (e) e?.stopPropagation();
    setFilterInputEl(null);
    setFilterInputOpen(false);
    if (!tempFilterState.length && type !== "applyFilter") {
      setSelectedSubjects([])
      setDisabledProp(false)
    }
  };

  const handleFilterInputClose1 = (e, type) => {
    if (e) e?.stopPropagation();
    setFilterInputEl1(null);
    setFilterInputOpen1(false);
  };

  useEffect(() => {
    if (disabledProp && !filterInputOpen) {
      let selectedSubjects = [...tempFilterState];
      setSelectedSubjects(selectedSubjects)
    }
  }, [disabledProp, filterInputOpen])

  const mapSubjectIconData = (subject) => {
    if (subjectIconData && subjectIconData.length > 0) {
      const item = subjectIconData.find(ele => ele['SubjectRackName.subject'] === subject)
      if (item) {
        let url = SUBJECT_ICON.replace('{ID}', item['SubjectRackName.rackNameId'])
        return <Avatar className='123' src={url} style={{ backgroundColor: '#0000' }}>
          <img src={GenericIcon} alt="subject_icon" />
        </Avatar>
      }
      else {
        return <Avatar className='456' src={GenericIcon} />
      }
    }
  }

  const handleStartDateReportFilter = async (date, endDate) => {
    //console.log('Handle Start Date')
    if (moment(date).isValid()) {
      let edMonth, edDay, edYear, stMonth, stDay, stYear
      let minEdDate = date;
      setMinEndDate(minEdDate);
      setIsSameDayEndTime(true)
      if (endDate) {
        edMonth = new Date(endDate).getMonth()
        edDay = new Date(endDate).getDay()
        edYear = new Date(endDate).getFullYear()
        stMonth = new Date(minEdDate).getMonth()
        stDay = new Date(minEdDate).getDay()
        stYear = new Date(minEdDate).getFullYear()


        if (edMonth !== stMonth || edDay !== stDay || edYear !== stYear) {
          setIsSameDayStartTime(false)
        }
        else {
          setIsSameDayStartTime(true)
        }
      }
      else {
        setIsSameDayEndTime(true)
      }
      date = moment(date).format("YYYY/MM/DD HH:mm:ss")
    }
    else {
      setIsSameDayEndTime(false)
      setMinEndDate(new Date("01/01/2021"))
      date = ''
    }
    setStartDate(date);
    let filter = {}
    if (endDate && date) {
      filter = {
        operator: "inDateRange",
        values: [date, endDate],
        dataSetType: 'DIMENSION',
        filterType: 'date_filter'

      }
    }
    else if (!date && endDate) {
      filter = {
        operator: "beforeDate",
        values: [endDate],
        dataSetType: 'DIMENSION',
        filterType: 'date_filter'
      }
    }
    else if (date && !endDate) {
      filter = {
        operator: "afterDate",
        values: [date],
        dataSetType: 'DIMENSION',
        filterType: 'date_filter'
      }
    }

    sheetsAvailable[selectedSheetIndex]?.reports.map(async report => {
      const reportFilter = JSON.parse(JSON.stringify(report?.reportFilters))


      if (!date) {
        let dateFilterIndex = reportFilter.findIndex(filter => filter?.filterType === 'date_filter')
        if (dateFilterIndex > -1) {
          reportFilter.splice(dateFilterIndex, 1)
        }

        filter = {}
      }


      const dateFilter = reportFilter.find(filter => filter?.filterType === 'date_filter')

      let dataSetName = null;
      if (report.dimensions?.length > 0) {
        dataSetName = report.dimensions[0]?.fieldName?.split('.')[0];
      }
      else if (report.measures?.length > 0) {
        dataSetName = report.measures[0]?.fieldName?.split('.')[0];
      }
      // const list = await getMeasuresList({ dataSetId: report?.dataSetId })
      let measureList = []

      if (dataSetMeasureList?.[report?.dataSetId]) {
        measureList = dataSetMeasureList?.[report?.dataSetId]
      }
      else {
        const list = await getMeasuresList({ dataSetId: report?.dataSetId })
        measureList = list?.result

        if (report?.dataSetId)
          dataSetMeasureList[report?.dataSetId] = measureList ?? []
      }


      if (measureList && measureList?.length) {
        let isMeas;
        isMeas = measureList.filter(meas => meas?.name === 'createDate')[0]
        if (!isMeas) {
          isMeas = measureList.filter(meas => meas?.name === 'assignDate')[0]
        }
        if (isMeas) {
          setLoading(true)
          filter.member = `${dataSetName}.${isMeas?.name}`
          if (!dateFilter) {
            if (filter?.operator)
              reportFilter.push(filter)            
          }
          else {
            reportFilter = reportFilter.map(obj => {
              if(obj.filterType == 'date_filter'){
                obj.values = filter?.values
                obj.operator = filter?.operator
              }
              return obj
            })
            /* dateFilter.member = `${dataSetName}.${isMeas?.name}`
            dateFilter.values = filter?.values;
            dateFilter.operator = filter?.operator */
          }
        }
      }
      report.reportFilters = [...JSON.parse(JSON.stringify(reportFilter))]
      return report
    })

    let newArray = [...sheetsAvailable];
    setSheetsAvailable(JSON.parse(JSON.stringify(newArray)));
    setLoading(false)
  }

  const handleEndDateReportFilter = async (date, startDate) => {
    //console.log('Handle End Date')
    if (moment(date).isValid()) {
      let edMonth, edDay, edYear, stMonth, stDay, stYear;
      let maxStDate = date
      setMaxStartDate(maxStDate)
      setIsSameDayStartTime(true)

      if (startDate) {
        edMonth = new Date(startDate).getMonth()
        edDay = new Date(startDate).getDay()
        edYear = new Date(startDate).getFullYear()
        stMonth = new Date(maxStDate).getMonth()
        stDay = new Date(maxStDate).getDay()
        stYear = new Date(maxStDate).getFullYear()


        if (edMonth !== stMonth || edDay !== stDay || edYear !== stYear) {
          setIsSameDayEndTime(false)
        }
        else {
          setIsSameDayEndTime(true)
        }
      } else {
        setIsSameDayStartTime(true)
      }

      date = moment(date).format("YYYY/MM/DD HH:mm:ss")
    }
    else {
      setIsSameDayStartTime(false)
      setMaxStartDate(Date.now())
      date = ''
    }
    setEndDate(date);
    let filter = {}
    if (startDate && date) {
      filter = {
        operator: "inDateRange",
        values: [startDate, date],
        dataSetType: 'DIMENSION',
        filterType: 'date_filter'

      }
    }
    else if (startDate && !date) {
      filter = {
        operator: "afterDate",
        values: [startDate],
        dataSetType: 'DIMENSION',
        filterType: 'date_filter'
      }
    }
    else if (!startDate && date) {
      filter = {
        operator: "beforeDate",
        values: [date],
        dataSetType: 'DIMENSION',
        filterType: 'date_filter'
      }
    }

    sheetsAvailable[selectedSheetIndex]?.reports.map(async report => {
      const reportFilter = JSON.parse(JSON.stringify(report?.reportFilters))
      if (!date) {
        let dateFilterIndex = reportFilter.findIndex(filter => filter?.filterType === 'date_filter')
        if (dateFilterIndex > -1) {
          reportFilter.splice(dateFilterIndex, 1)
        }

        filter = {}
      }


      const dateFilter = reportFilter.find(filter => filter?.filterType === 'date_filter')
      let dataSetName = null;
      if (report.dimensions?.length > 0) {
        dataSetName = report.dimensions[0]?.fieldName?.split('.')[0];
      }
      else if (report.measures?.length > 0) {
        dataSetName = report.measures[0]?.fieldName?.split('.')[0];
      }

      // const list = await getMeasuresList({ dataSetId: report?.dataSetId })
      let measureList = []

      if (dataSetMeasureList?.[report?.dataSetId]) {
        measureList = dataSetMeasureList?.[report?.dataSetId]
      }
      else {
        const list = await getMeasuresList({ dataSetId: report?.dataSetId })
        measureList = list?.result

        if (report?.dataSetId)
          dataSetMeasureList[report?.dataSetId] = measureList ?? []
      }


      if (measureList && measureList?.length) {
        let isMeas = measureList.find(meas => meas?.name === 'createDate' || meas?.name === 'assignDate')
        if (isMeas) {
          setLoading(true)
          filter.member = `${dataSetName}.${isMeas?.name}`
          //console.log({...filter})
          if (!dateFilter) {
            if (filter?.operator)
              //console.log({...filter})
              reportFilter.push(filter)
          }else {
            reportFilter = reportFilter.map(obj => {
              if(obj.filterType == 'date_filter'){
                obj.values = filter?.values
                obj.operator = filter?.operator
              }
              return obj
            })
            //console.log(`${dataSetName}.${isMeas?.name}`)
            /* dateFilter.member = `${dataSetName}.${isMeas?.name}`
            dateFilter.values = filter?.values;
            dateFilter.operator = filter?.operator */
          }
          //console.log(isMeas,dataSetName,{...dateFilter},[...reportFilter])
        }
      }
      report.reportFilters = [...JSON.parse(JSON.stringify(reportFilter))]
      return report
    })

    let newArray = [...sheetsAvailable];
    setSheetsAvailable(JSON.parse(JSON.stringify(newArray)));
    setLoading(false)
  }

  const handleSubjectFilterLabel = () => {
    if (!subjectFilterData?.length) {
      return handleLanguageChange('Select Subject')
    }
    else if (isArrayEqual(subjectFilterData, selectedSubjects)) {
      return handleLanguageChange('All Subjects Selected')
    }
    else if (selectedSubjects.length === 1) {
      return selectedSubjects[0]
    }
    else if (selectedSubjects.length > 1) {
      return `${handleLanguageChange('Subject')} (${selectedSubjects.length})`
    }
    else {
      return handleLanguageChange('Select Subject')
    }
  }

  const handleTimeFilterLabel = () => {
    if (selectedPeriod) {
      return handleLanguageChange(selectedPeriod)
    }
    else {
      return handleLanguageChange("Select Time Period")
    }
  }

  useEffect(() => {
    // if (startDate || endDate)
    getCustomQueryData()
  }, [endDate])

  const periodList = [
    'Yesterday',
    'This Week',
    'Last Week',
    'Last Month',
    'Custom'
  ]

  return (
    <RootStyle>
      <MainStyle>
        <Outlet />

        <Box className="embed-reports" >
          {(loading && !studentId) && <Loader />}
          <Grid container mb={2} >
            {/* <Grid container item alignItems="start" justifyContent="flex-start" sm={12} md={12} lg={12} >
              <Box className="er-heading" sx={{ pb: '2rem' }}>
                <Typography className="er-heading-title" variant="h2" noWrap>{handleLanguageChange("Reports")}</Typography>
              </Box>
            </Grid> */}

            {/* PAR-1016 */}
            {lang === 'parent_en' || lang === 'parent_hi' ? null : <Grid className='er-heading-content' item alignItems="start" justifyContent="flex-start" sm={12} md={12} lg={12} >
              <Box className="er-content mt-0">
                <Typography className="er-heading-title-sub" variant="h4" noWrap>{handleLanguageChange("Progress and Performance Reports")}</Typography>
                <Typography className="er-heading-subtitle" variant="p" >{handleLanguageChange("Comprehensive analysis to track your progress")}</Typography>
              </Box>
            </Grid>}

            {
              !studentId &&
              <Grid item alignItems="start" justifyContent="flex-start" sm={12} md={12} lg={12} >
                <Box className="er-profiles" sx={{ width: carousalWidth }}>
                  {profiles?.length ? <Tabs
                    value={selectedTab}
                    onChange={handleProfileChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="scrollable"
                    scrollButtons="auto"
                    TabIndicatorProps={{
                      style: {
                        display: "none",
                      },
                    }}
                  >
                    {(profiles.length) ? <Tab
                      key="0"
                      className={"er-profile-title"}
                      //onClick={handleProfileChange}
                      value={`all.0`}
                      label={
                        <Box >
                          <Typography variant='h4' className="inline-item" >{handleLanguageChange('All')}</Typography>
                        </Box>
                      }>
                    </Tab> : null}
                    {
                      profiles?.map((itm, i) => (
                        <Tab
                          key={i}
                          className={"er-profile-title"}
                          //onClick={handleProfileChange}
                          value={`${itm?.profile}.${i}`}
                          id={`${itm?.profile}.${i}`}
                          label={
                            <Box className='er-profiles-content'>
                              <Box sx={{ w: '35px', h: '35px' }}>
                                {/* <ProfileIcon className="inline-item" /> */}
                                <img src={PORFILE_AVATAR.replace('{ID}', itm?.avatarId)} alt="profile_icon" className="inline-item" />
                              </Box>

                              <Typography variant='h4' className="er-profiles-content-title inline-item" >{handleLanguageChange(itm?.profile)}</Typography>
                            </Box>
                          }>
                        </Tab>
                      ))
                    }
                  </Tabs> : null}
                </Box>
              </Grid>
            }

            <Grid item alignItems="start" justifyContent="flex-start" sm={12} md={12} lg={12} className="width-100p mt-1" >

              <Box className={`chart-carousel ` + carousalCards + ` ` + (isMobileView() ? 'chart-carousel-mobile' : ``)} sx={{ width: '100%', height: '100%' }}>

                <Box className={`re-carousel-wrapper student-report-carousel`}>
                  <Swiper
                    
                    spaceBetween={isMobileView() ? 10: 20}
                    slidesPerView={(window.innerWidth < 1200) ? (isMobileView() ? 1.1 : 3) : 4}
                    modules={[Navigation]}
                    navigation={isMobileView() ? false : {
                      prevEl: `${'.swiper-prev-arrow'}`,
                      nextEl: `${'.swiper-next-arrow'}`,
                    }}
                    >
                      {statistics?.map((item, index) => (
                        <SwiperSlide key={index}>
                          <PerformanceCards item={item} index={index} selectedProfile={selectedProfile} profileReportIds={profileReportIds} studentId={studentId} />
                        </SwiperSlide>
                      ))}
                    </Swiper>
                    {
                      isMobileView() 
                        ? null
                        : <>
                            <IconButton className={`swiper-nav-arrow er-slide-left-nav swiper-prev-arrow`}><LeftNavIcon /></IconButton>
                            <IconButton  className={`swiper-nav-arrow er-slide-right-nav swiper-next-arrow`}><RightNavIcon /></IconButton>
                          </>
                    }
                </Box>
              </Box>

            </Grid>

          </Grid>

          <Grid container item className='re-sr-filter-grid' alignItems="start" justifyContent="flex-start" spacing={2} sm={12} md={12} lg={12} my={2} >
            <Grid item xs={12} md={6} lg={6}>
              <Box className="re-custom-dropdown-popper">
                <Box className={`select_filters_input er-input-filter quick-filter-item ` + (selectedSubjects?.length ? ' has-value' : ` `)} onClick={handleFilterInputClick} ref={selectFiltersInput} >
                  <Box style={{ overflow: 'hidden' }} className="select_filters_input_item" display="flex" alignItems="center">
                    <Typography variant='subtitle'>
                      {handleSubjectFilterLabel()}
                    </Typography>
                  </Box>
                  <Box className={`select_filters_input_item filter-select-icon ` + (filterInputOpen ? ` on-open` : ` `)}><DropDownIcon /></Box>
                </Box>
                {
                filterInputOpen && <ClickAwayListener onClickAway={() => setFilterInputOpen(false)}>
                  <Popper
                    id={filterInputId}
                    open={filterInputOpen}
                    anchorEl={filterInputEl}
                    onClose={e => handleFilterInputClose(e)}
                   // anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                    //PaperProps={{ classes: { root: 'filter-item-options quick-filter-popover' } }}
                    disabled={false}
                    placement="bottom-start"
                    disablePortal={true}
                    className='re-custom-dropdown-popper-root'
                  >
                    <Box className='filter-item-options quick-filter-popover'>
                      <Box className="filters-dropdown-item quick-filter-dd" sx={{ width: selectFilterWidth }}>

                        {subjectsLoader ? <LinearProgress /> : null}

                        {subjectFilterData?.length ?
                          <Box className="filters-dropdown-item-content student-report-filter-content">
                            <FormControlLabel className="filters-view-checkbox menu-item select-all-option" label="Select All"
                              control={<Checkbox className="form_checkbox" size="small" icon={<CheckBoxIcon />} checkedIcon={<CheckBoxCheckedIcon />}
                                checked={isArrayEqual(subjectFilterData, selectedSubjects)} onChange={handleSelectAllSubjects} />} />
                                
                            <div className={`virtual-filter-div ` + ((subjectFilterData.length) ? 'filter-data-exists' : ``)
                              + ((subjectFilterData.length && subjectFilterData.length < 5) ? ` filter-data-auto ${numberValues[subjectFilterData.length-1]}` : ` `)}>
                              <AutoSizer>
                                {({ height, width }) => (
                                  <FixedSizeList
                                    className="List"
                                    height={subjectFilterData?.length ? height : 20}
                                    itemCount={subjectFilterData?.length}
                                    width={width - 6}
                                    itemData={subjectFilterData}
                                    itemSize={48}
                                  >
                                    {MultiSelectRow}
                                  </FixedSizeList>
                                )}
                              </AutoSizer>
                            </div>
                          </Box> :
                          subjectsLoader ? null : <Box alignItems="center" justifyContent="center" className="select_filters_input_item">
                            <Typography className="filters-dropdown-item-label student-report-filter-no-result" >No Subjects</Typography>
                          </Box>}

                        <Box className="filters-dropdown-item-footer">
                          <Button sx={{ mr: 2 }} className="report_form_fltr_btn" variant='outlined' onClick={handleUnSelectAllSubjects} disabled={selectedSubjects?.length < 1} >{handleLanguageChange("Clear All")}</Button>
                          <Button onClick={applyFilterOnReports}
                            disabled={(!selectedSubjects.length && !disabledProp)} className="report_form_ui_btn submit" variant="contained">{handleLanguageChange("Apply")}</Button>
                        </Box>
                      </Box>
                    </Box>
                  </Popper>
                </ClickAwayListener>
                }
              </Box>
            </Grid>

            <Grid item xs={12} md={6} lg={6}>
              <Box className="re-custom-dropdown-popper">
                <Box className={`select_filters_input er-input-filter quick-filter-item ` + (selectedPeriod ? ` has-value` : ` `)} onClick={handleFilterInputClick1} ref={selectFiltersInput1} >
                  <Box style={{ overflow: 'hidden' }} className="select_filters_input_item" display="flex" alignItems="center">
                    <Typography variant='subtitle'>
                      {handleTimeFilterLabel()}
                    </Typography>
                  </Box>
                  <Box className={`select_filters_input_item filter-select-icon ` + (filterInputOpen1 ? ` on-open` : ` `)}><DropDownIcon /></Box>
                </Box>
                {
                  filterInputOpen1 && <ClickAwayListener onClickAway={() => setFilterInputOpen1(false)}>
                  <Popper
                    id={filterInputId1}
                    open={filterInputOpen1}
                    anchorEl={filterInputEl1}
                    onClose={e => handleFilterInputClose1(e)}
                    //anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                    disabled={false}
                    placement="bottom-start"
                    disablePortal={true}
                    className='re-custom-dropdown-popper-root'
                  >
                    <Box className='filter-item-options quick-filter-popover'>
                      <Box className="filters-dropdown-item quick-filter-dd" sx={{ width: selectFilterWidth }}>
                        <Box className="filters-dropdown-item-content student-report-filter-content">
                          <RadioGroup name="controlled-radio-buttons-group" value={""} >
                            <div className=" ">
                              <div className={`virtual-filter-div ` + ((periodList.length) ? 'filter-data-exists' : ``)
                                + ((subjectFilterData.length && periodList.length < 5) ? ` filter-data-auto ${numberValues[periodList.length-1]}` : ` `)}>
                                <AutoSizer>
                                  {({ height, width }) => (
                                    <FixedSizeList
                                      className="List"
                                      height={periodList?.length ? height : 20}
                                      itemCount={periodList?.length}
                                      width={width - 6}
                                      itemData={periodList}
                                      itemSize={48}
                                    >
                                      {MultiSelectRow1}
                                    </FixedSizeList>
                                  )}
                                </AutoSizer>
                              </div>
                              {
                                selectedPeriod === "Custom" &&
                                <Grid container spacing={2} sx={{ px: "2rem" }}>
                                  <Grid item lg={6} className="max-w100">
                                    <DatePicker
                                      dateFormat="dd/MM/yyyy"
                                      placeholderText={handleLanguageChange("Start Date")} className="report_form_ui_input_date er-input-filter mb-1"
                                      minDate={new Date("01-01-2021")}
                                      maxDate={maxStartDate}
                                      minTime={new Date("2021-01-01")}
                                      onKeyDown={(e) => {
                                        e.preventDefault();
                                      }}
                                      onChangeRaw={(e) => e.preventDefault()}
                                      maxTime={!isSameDayStartTime ? moment.utc().endOf('day') : maxStartDate}
                                      selected={startDate ? new Date(startDate) : null} onChange={(date) => handleStartDateReportFilter(date, new Date(maxStartDate))}
                                      isClearable
                                      customInput={
                                        <TextField className="report_form_ui_input_date er-input-filter"
                                          InputProps={{
                                            endAdornment: (
                                              <InputAdornment position="start">
                                                <CalendarIcon className="er-input-calendar-icon" />
                                              </InputAdornment>
                                            ),
                                          }}
                                          inputProps={{
                                            autoComplete: 'off',
                                          }}
                                        />
                                      }
                                    />
                                  </Grid>
                                  <Grid item lg={6} className="max-w100">
                                    <DatePicker
                                      dateFormat="dd/MM/yyyy"
                                      minDate={minEndDate}
                                      maxDate={new Date()} placeholderText={handleLanguageChange("End Date")} className="report_form_ui_input_date er-input-filter mb-1"
                                      selected={endDate ? new Date(endDate) : null} onChange={(date) => handleEndDateReportFilter(date, minEndDate)}
                                      minTime={!isSameDayEndTime ? moment.utc().endOf('day') : setHours(setMinutes(new Date(), new Date(minEndDate).getMinutes()), new Date(minEndDate).getHours())}
                                      maxTime={new Date().setHours(23, 59, 59, 999)}
                                      onKeyDown={(e) => {
                                        e.preventDefault();
                                      }}
                                      onChangeRaw={(e) => e.preventDefault()}
                                      isClearable
                                      customInput={
                                        <TextField className="report_form_ui_input_date er-input-filter"
                                          InputProps={{
                                            endAdornment: (
                                              <InputAdornment position="start">
                                                <CalendarIcon className="er-input-calendar-icon" />
                                              </InputAdornment>
                                            ),
                                          }}
                                          inputProps={{
                                            autoComplete: 'off',
                                          }}
                                        />
                                      }
                                    />
                                  </Grid>
                                </Grid>
                              }
                            </div>
                          </RadioGroup>
                        </Box>
                        <Box className="filters-dropdown-item-footer student-report-filter-footer">
                          <Button sx={{ mr: 2 }} className="report_form_fltr_btn" variant='outlined' onClick={clearFilterHandler}>{handleLanguageChange("Clear")}</Button>
                          {
                            selectedPeriod === "Custom" ?
                              <Button onClick={handleFilterInputClose1} disabled={!selectedPeriod} className="report_form_ui_btn submit" variant="contained">{handleLanguageChange("Apply")}</Button>
                              :
                              <Button onClick={() => getPeriodValueHandler(selectedPeriod)} disabled={!selectedPeriod} className="report_form_ui_btn submit" variant="contained">{handleLanguageChange("Apply")}</Button>
                          }
                        </Box>
                      </Box>
                    </Box>
                  </Popper>
                </ClickAwayListener>
                }
              </Box>
            </Grid>
          </Grid>

          {
            (selectedSubjects?.length > 1 || selectedSubjects?.length === 0) ?
              <Grid item alignItems="start" justifyContent="flex-start" sm={12} md={12} lg={12} mt={4} mb={2} >
                <Box className="er-content" >
                  <Typography className="er-heading-title-sub" variant="h4" noWrap>{handleLanguageChange("Subject-wise Analysis")}</Typography>
                  <Typography className="er-heading-subtitle" variant="p" >{handleLanguageChange("Subject-wise data driven analysis to monitor your performance")}</Typography>
                </Box>
              </Grid>
              : null
          }

          <Grid item xs={12} md={12}>
            <Box ref={containerRef} className={classes.reportGraphs}>
              {sheetsAvailable?.length && sheetsAvailable[selectedSheetIndex]?.reports ?
                <DashboardChartLayoutV2
                  onLayoutChange={onLayoutChange}
                  containerWidth={containerWidth}
                  selectedReports={sheetsAvailable[selectedSheetIndex]?.reports}
                  updateReportsList={updateReportsList}
                  bodyRef={bodyRef}
                  handleSelectReport={handleSelectReport}
                  learningProfileMapping={learningProfileMapping}
                  currentProfile={currentProfile}
                  selectedProfile={selectedProfile}
                  profiles={profiles}
                  studentId={studentId}
                /> : null}
            </Box>
          </Grid>

          <Grid item alignItems="start" justifyContent="flex-start" sm={12} md={12} lg={12} mt={4} mb={2} className='er-section-keyareas' >
            <Box className="er-content" >
              <Typography className="er-heading-title-sub" variant="h4" noWrap>{handleLanguageChange("Key Areas of Improvement")}</Typography>
              <Typography className="er-heading-subtitle" variant="p" >{handleLanguageChange("Identify and work on weak areas to ace your exams")}</Typography>
            </Box>
          </Grid>

          <Grid container item spacing={2} sm={12} md={12} lg={12} mb={2} >
            <KeyTimePerformance mapSubjectIconData={mapSubjectIconData}
              handleCustomDataFilter={handleCustomDataFilter}
              handleCustomProfileDataFilter={handleCustomProfileDataFilter}
              handleCustomDateFilter={handleCustomDateFilter}
              keyTimeMetricsQuery={keyTimeMetricsQuery}
              studentId={studentId}
              profileReportIds={profileReportIds}
              selectedProfile={selectedProfile}
            />

            <KeyMarksPerformance mapSubjectIconData={mapSubjectIconData}
              handleCustomDataFilter={handleCustomDataFilter}
              handleCustomProfileDataFilter={handleCustomProfileDataFilter}
              handleCustomDateFilter={handleCustomDateFilter}
              keyMarksMetricsQuery={keyMarksMetricsQuery}
              studentId={studentId}
              profileReportIds={profileReportIds}
              selectedProfile={selectedProfile}
            />
          </Grid>
        </Box>
      </MainStyle>
    </RootStyle>

  )
}
